import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CustomerService } from 'src/app/shared/customer/customer.service';
import { LoginService } from 'src/app/shared/user-login/login.service';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-get-transactions',
    templateUrl: './get-transactions.component.html',
    styleUrls: ['./get-transactions.component.css'],
    standalone: false
})
export class GetTransactionsComponent implements OnInit {

  role;
  user
  serverErrorMessages;
  customer
  customerId = 'ID unavailable'
  customerName = 'Name unavailable'
  myTransactions
  alltransactions;
  startDate;
  endDate;
  purpose;
  transaction
  transactions;
  loading: Boolean = true
  dateForm = new FormGroup({
    startDate: new FormControl(),
    endDate: new FormControl(),
    selectedPurpose: new FormControl()
  })
  pdfLoading: boolean = false
  missingFields = false

  purposes = ["Subscription", "AMC", "Calibration", "Initial Deposit","Curve Generation","Ticket Generation"]
  constructor(private loginService: LoginService, private router : Router, private customerService: CustomerService, private datePipe: DatePipe) { }

  ngOnInit(): void {
    this.endDate =this.transformDate(new Date());
    if(this.loginService.isLoggedIn()){
      this.loginService.getUserProfile().subscribe(
        res => {
          this.user = res['user']
          this.role = res['user'].role.toString();
         //console.log('User', this.role);
          this.getAllTransactions();
          this.loading = false;
         //console.log(this.endDate);
        },
        err => {
         //console.log('Didnt get logged in user', err);
          this.serverErrorMessages = err.error.message;
          this.loading = false;
        }
      )
    }
  }

  unauthorised(){
    setTimeout(() => {
      this.loginService.deleteToken();
     //console.log('BYE BYE');
      this.router.navigateByUrl('/signin');
    }, 3000);
  }

  getAllTransactions(){
    this.customerService.getTransactions().subscribe(
      res=>{
        this.customer = res['transactions'][0];
        if(this.customer.customerId)
        {
          this.customerId = this.customer.customerId._id;
          this.customerName = this.customer.customerId.fullName;
        }
        
        this.transaction = this.customer
        this.alltransactions = this.transaction['transactions']
        this.transactions=this.alltransactions
       console.log(this.customer);
      },
      err=>{
       //console.log('error getting transacions', err)
      }
    )
  }

  filter(){
    this.startDate=this.transformDate(this.dateForm.get('startDate').value)
    this.endDate=this.transformDate(this.dateForm.get('endDate').value)
    this.purpose=this.dateForm.get('selectedPurpose').value
    // if ( !this.startDate || !this.endDate ) this.missingFields=true
    // else {
      // console.log(this.startDate, this.endDate)
      this.transactions = []
      for (var x of this.alltransactions) {
        var d = this.transformDate(x.createdAt)
        if(x.Purpose)
        {
          var p = x.Purpose
        }
        else{
          var p = x.purpose
        }

        if ( this.startDate && this.endDate )
        {
        
        if (d>=this.startDate && d<=this.endDate) {
          if(this.purpose)
          { console.log(this.purpose)
            if(p == this.purpose)
            {
              this.transactions.push(x)    
            }
          }
          else
          {
            this.transactions.push(x)
          }
          
        }
        }

        else
        {
          if(this.purpose)
          { console.log(this.purpose)
            if(p == this.purpose)
            {
              this.transactions.push(x)    
            }
          }
          else
          {
            this.transactions.push(x)
          }
        }
      }
      
      this.missingFields=false
      console.log("New transactions", this.transactions)
    
  }

  reset() {
    this.dateForm.reset()
    this.missingFields=false
    this.transactions = this.alltransactions;
  }

  transformDate(x){
    return(this.datePipe.transform(x, 'yyyy-MM-dd'));
  }

  sendInvoice(){
    
    
      this.pdfLoading = true;
      const customerID = this.user['_id']
    ////console.log(customerID)
    const fullName = this.user['fullName']
    this.customerService.sendInvoiceDateFilter(customerID,this.startDate,this.endDate)
    .then(resp => resp.arrayBuffer()).then(resp => {
      const file = new Blob([resp], {type: 'application/pdf'});
      // process to auto download it
      const fileURL = URL.createObjectURL(file);
      const link = document.createElement('a');
      link.href = fileURL;
      link.download = customerID + '_' + fullName + '_' + this.datePipe.transform(Date.now(), 'yyyy-MM-dd') + ".pdf";
      link.click();
      this.pdfLoading = false;
    });
    
    
    
  }

}
